// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import shieldTickIcon from "@/assets/icons/shield-tick.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ShieldTickIconProps = Omit<IconProps, "name">;

export function ShieldTickIcon(props: ShieldTickIconProps): React.ReactNode {
  return <Icon name={shieldTickIcon} {...props} />;
}
